/**
 * Normalize a store "latest version" string to marketing semver (x.y.z).
 *
 * Play Console release.name is often "{versionCode} ({versionName})"
 * e.g. "30000233 (5.26.2)". Comparing that raw string with semver split
 * treats 30000233 as the major and rejects valid bumps like 5.26.5.
 */
export function normalizeStoreMarketingVersion(
  raw: string | null | undefined
): string | null {
  const s = String(raw || "").trim();
  if (!s) return null;

  const paren = s.match(/\((\d+\.\d+\.\d+)\)/);
  if (paren) return paren[1];

  if (/^\d+\.\d+\.\d+$/.test(s)) return s;

  const any = s.match(/\d+\.\d+\.\d+/);
  return any ? any[0] : null;
}

export function cmpMarketingVersion(a: string, b: string): number {
  const parse = (s: string) =>
    s
      .split(".")
      .map(n => parseInt(n, 10))
      .map(n => (Number.isNaN(n) ? 0 : n));
  const aa = parse(a);
  const bb = parse(b);
  const len = Math.max(aa.length, bb.length);
  for (let i = 0; i < len; i++) {
    const da = aa[i] || 0;
    const db = bb[i] || 0;
    if (da !== db) return da - db;
  }
  return 0;
}
